import { Api } from 'utils';

class ClientHomeService {
	
	static client = {
		getServices: async (params?: any) => Api.createResponse('client/home/services',params),
		getContactInfo: async (params?: any) => Api.createResponse('client/home/contact-info',params),
		sendEmails: async (params?: any) => Api.createResponse('client/home/send-emails',params),
		checkQuotes: async (params?: any) => Api.createResponse('client/home/check-quotes',params),
	}

}

export default ClientHomeService;